import { call, put, takeLatest } from "redux-saga/effects";
import {
    addSpecialistFailure,
    addSpecialistSuccess,
    deleteSpecialistFailure,
    deleteSpecialistSuccess,
    fetchSpecialistFailure,
    fetchSpecialistsFailure,
    fetchSpecialistsSuccess,
    fetchSpecialistSuccess,
    updateSpecialistFailure,
    updateSpecialistSuccess,
} from "./specialistAction";
import {
    addSpecialistEffect,
    deleteSpecialistEffect,
    editSpecialistEffect,
    listSpecialistEffect,
    viewSpecialistEffect,
} from "./specialistEffect";
import {
    ADD_SPECIALIST_REQUEST,
    DELETE_SPECIALIST_REQUEST,
    FETCH_LIST_SPECIALIST_REQUEST,
    FETCH_SPECIALIST_REQUEST,
    UPDATE_SPECIALIST_REQUEST,
} from "./specialistType";

function* fetchSpecialistsSaga(action) {

    try {
        const response = yield call(listSpecialistEffect,action.payload); 
        yield put(fetchSpecialistsSuccess(response.data));
    } catch (error) {
        yield put(fetchSpecialistsFailure(error.message));
    }
}

function* fetchSpecialistSaga(action) {
    try {
        const response = yield call(viewSpecialistEffect, action.payload.specialistId);
        yield put(fetchSpecialistSuccess(response.data));
    } catch (error) {
        yield put(fetchSpecialistFailure(error.message));
    }
}

function* addSpecialistSaga(action) {
    try {
        const response = yield call(addSpecialistEffect, action.payload.specialistData);
        yield put(addSpecialistSuccess(response.data));
    } catch (error) {
        yield put(addSpecialistFailure(error.message));
    }
}

function* updateSpecialistSaga(action) {
    try {
        const response = yield call(
            editSpecialistEffect,
            action.payload.specialistId,
            action.payload.specialistData
        );
        yield put(updateSpecialistSuccess(response.data));
    } catch (error) {
        yield put(updateSpecialistFailure(error.message));
    }
}

function* deleteSpecialistSaga(action) {
    try {
        yield call(deleteSpecialistEffect, action.payload.specialistId);
        yield put(deleteSpecialistSuccess(action.payload.specialistId));
    } catch (error) {
        yield put(deleteSpecialistFailure(error.message));
    }
}

export function* specialistSagas() {
    yield takeLatest(FETCH_LIST_SPECIALIST_REQUEST, fetchSpecialistsSaga);
    yield takeLatest(FETCH_SPECIALIST_REQUEST, fetchSpecialistSaga);
    yield takeLatest(ADD_SPECIALIST_REQUEST, addSpecialistSaga);
    yield takeLatest(UPDATE_SPECIALIST_REQUEST, updateSpecialistSaga);
    yield takeLatest(DELETE_SPECIALIST_REQUEST, deleteSpecialistSaga);
}